import React, { Fragment, useEffect, useMemo, useState } from "react";
import DataTable from "./DataTable";
import VisibleColumns from "./VisibleColumn";
import ErrorBoundary from "../../ErrorBoundry";
import { useNavigate } from "react-router-dom";
import {
  faEye,
  faUserClock,
  faUserTie,
} from "@fortawesome/pro-duotone-svg-icons";
import { Container, Row } from "reactstrap";
import { Typography } from "@mui/material";
import Header from "./Header";

const PayrollEmployeeRole = ({ isLoading, deleteResult, ...props }) => {
  const history = useNavigate();
  const [deleteData, setDeleteData] = useState(null);
  const actions = useMemo(() => {
    return [
      {
        title: "View",
        action: (props) => {
          return history(
            `/supervisor-employees/${props.dataItem.EmployeeNo}`
          );
        },
        icon: { iconName: 'k-icon  k-i-eye' },
        className: "font-primary",
        style: { cursor: "pointer" },
        onlyVisible: "Supervisor",
        // viewAction: true,
        role:"SupervisionRole"
      },
      {
        title: "Make Supervisor",
        action: (props) => {
          return history(
            `/assign-supervisor-employees/${props.dataItem.EmployeeNo}`
          );
          //   const url = `/master-detail/${props.dataItem.ID}`;
          //   window.open(url, "_blank");
        },
        icon: faUserTie,
        className: "font-primary",
        style: { cursor: "pointer" },
        onlyVisible: "Employee",
        role:"SupervisionRole"

        // supervisorAction: true,
      },
      // {
      //   title: "Make TimeKeeper",
      //   action: (props) => {
      //     return history(
      //       `/assign-timekeeper-employees/${props.dataItem.EmployeeNo}`
      //     );
      //   },
      //   icon: faUserClock,
      //   className: "font-primary",
      //   style: { cursor: "pointer" },
      //   onlyVisible: "SupervisionRole",
      //   // role: "SUPER-USER",
        
      //   // timekeeperAction: true,
      // },
    ];
  });
 

  useEffect(() => {
    if (
      deleteResult != undefined &&
      !!Object.keys(deleteResult).length &&
      !isLoading
    ) {
      setDeleteData({ dt: new Date() });
    }
  }, [deleteResult, isLoading]);

  return (
    <ErrorBoundary>
      <Fragment>
        <Container fluid={true}>
          <Row>
            <Header title={"Supervisor Assignment"} url={"payroll-employees"} />
          </Row>
        </Container>
      </Fragment>
      <DataTable
        tableName={"vw_PayrollEmployeeListingByRole_V2"}
        visibleColumns={VisibleColumns}
        title={`PR Employees`}
        sort={[{ field: "EmployeeNo", dir: "asc" }]}
        deleteData={deleteData}
        isLoading={isLoading}
        additionalWheres={""}
        actions={actions}
        
        isPayrollEmployee={true}
      />
    </ErrorBoundary>
  );
};

export default PayrollEmployeeRole;
